const IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'heic',
  'heif',
  'bmp',
  'tiff',
];

export const getFileExtension = (name: string) => name.split('.').pop()?.toLowerCase() ?? '';

export const isImageSource = (source?: string | null, type?: string) => {
  if (type?.startsWith('image/')) return true;
  if (!source) return false;
  const withoutQuery = source.split('?')[0];
  return IMAGE_EXTENSIONS.includes(getFileExtension(withoutQuery));
};
